import React, {Component} from 'react';
import {Grid, Col, Row, Button, FormControl} from 'react-bootstrap';

import Datetime from 'react-datetime'
import moment from 'moment'
import Select   from 'react-select'
 import {ADD_SELECTED_TRANSACTIONS, CLEAR_SELECTED_TRANSACTIONS} from 'actions/actionTypes';
import {prepareSelectOptionsList,} from 'util/Utils';
import config from  '../../../config';




export default class PartnerTransactionSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        let Types =  _.isUndefined(this.props.location.query.Types) ? [
         ] : Array.isArray(this.props.location.query.Types) ? this.props.location.query.Types.map(item=>{
           return config.transactionTypesMap.find(transactionType => transactionType.value == item);
          }) : [config.transactionTypesMap.find(transactionType => transactionType.value == this.props.location.query.Types)];
        Types = Types.filter(Boolean);

      var stateData =   {
             filterOptions: {
                 perPage: _.isUndefined(this.props.location.query.perPage) ?  30 : this.props.location.query.perPage,
                 SellerID: _.isUndefined(this.props.location.query.SellerID) ? 'all' : this.props.location.query.SellerID,
                 'fromPaidDateDisplay': _.isUndefined(this.props.location.query.fromPD) ? '' : moment(this.props.location.query.fromPD),
                'toPaidDateDisplay': _.isUndefined(this.props.location.query.toPD) ? '' : moment(this.props.location.query.toPD),
                 'fromFulfilledTimeDisplay': _.isUndefined(this.props.location.query.fromFD) ? '' : moment(this.props.location.query.fromFD),
                 'toFulfilledTimeDisplay': _.isUndefined(this.props.location.query.toFD) ? '' : moment(this.props.location.query.toFD),
                 Types:Types,
                 searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
                  currentPage: _.isUndefined(this.props.location.query.page) ? 1 : parseInt(this.props.location.query.page),
                  recordIDs:  _.get(this.props.location.query, 'recordIDs', [])
            }
        };

        if( stateData.filterOptions.recordIDs.length == 0 && stateData.filterOptions.SellerID == 'all' &&
          stateData.filterOptions.fromPaidDateDisplay == '' && stateData.filterOptions.toPaidDateDisplay == '' &&
          stateData.filterOptions.fromFulfilledTimeDisplay == '' && stateData.filterOptions.toFulfilledTimeDisplay == '' &&
          stateData.filterOptions.searchText == '') {
            stateData.filterOptions.fromFulfilledTimeDisplay  = moment().subtract(2, 'month');
        }

        this.state =stateData
        this.allSellersOptionsList = prepareSelectOptionsList(this.props.allSellersList.data, {
            label: 'DisplayName',
            value: '_id'
        })
         this.allCreatedByOptionsList = [ ]

        this.onCreateTimeChange = this.onCreateTimeChange.bind(this);
        this.allSellersOptionsList.unshift({label: 'All', value: 'all'});
    };

    componentWillReceiveProps(nextProps) {


        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })

        }
    }

    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}});
    }

    getSearchParams(filtersChanged = {}) {
        let filterOptions = {...this.state.filterOptions, ...filtersChanged};
        let queryParams = {
           useAnalyticDatabase:true
        };
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }

        if(filterOptions.currentPage > 1) {
          queryParams.page = filterOptions.currentPage;
        }
        if (filterOptions.SellerID !== 'all') {
            queryParams.SellerID = filterOptions.SellerID;
        }
        if (filterOptions.fromPaidDateDisplay !== '') {
            queryParams.fromPD = filterOptions.fromPaidDateDisplay.toISOString()
        }
        if (filterOptions.toPaidDateDisplay !== '') {
            queryParams.toPD = filterOptions.toPaidDateDisplay.toISOString()
        }

        if (filterOptions.fromFulfilledTimeDisplay !== '') {
            queryParams.fromFD = filterOptions.fromFulfilledTimeDisplay.toISOString();
        }

        if (filterOptions.toFulfilledTimeDisplay !== '') {
            queryParams.toFD = filterOptions.toFulfilledTimeDisplay.toISOString();
        }

        if (filterOptions.Types.length) {
          queryParams.Types =  filterOptions.Types.map(item=>item.value);
        }else{
          queryParams.Types = ['Sale',  'Fee', 'Credit'];
        }

         if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        if ( _.size(filterOptions.disposition) ) {
            queryParams.disposition = _.map(filterOptions.disposition, 'value')
        }

         return {queryParams}
    }

    onSelectAllTransactionsChange() {
        var self = this;
        if (!this.props.selectAllTransactions) {

            this.props.search({include: ['_id'], all: true}).then(response => {
                self.props.toggleAllTransactionsSelection(true)
                self.props.dispatchAction(response.data.data, ADD_SELECTED_TRANSACTIONS)
            });
        } else {
            this.props.toggleAllTransactionsSelection(false);

            this.props.dispatchAction({}, CLEAR_SELECTED_TRANSACTIONS)
        }
    }





    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }





    onSellerChange(option) {

        var updateOptions = {...this.state.filterOptions, SellerID:  option ? option.value:null};
        this.setState({'filterOptions': updateOptions});
    }


    onCreateTimeChange(option, createTimeOptionName) {

        var updateOptions = {...this.state.filterOptions, [createTimeOptionName]: option};
        this.setState({'filterOptions': updateOptions});
    }



    onPriceChange(event, priceOptionName) {
         this.setState({'filterOptions': {...this.state.filterOptions, [priceOptionName]: event.target.value}});
    }

    render() {
        var self = this;


        return (
            <div className="transaction-search-block">
                <Row className="show-grid">

                    <Col md={2} sm={2}  xs={3}  className="top10">
                    <Button className="btn btn-primary" disabled={this.props.pending}  onClick={this.onSelectAllTransactionsChange.bind(this)}>
                        {this.props.selectAllTransactions ? 'Clear selection' : 'Select all' }
                    </Button>
                </Col>
                    <Col  md={1} sm={2}  xs={3} className="top10">
                        <Select
                            tabIndex="0"
                            //  onBlur={ collapse }
                            //optionRenderer={renderOption}
                            //valueRenderer={renderValue}
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>
                </Row>

                <Row  >
                    <Col xs={8} md={3} sm={3}className=" top10 pright0">
                        <FormControl type="text"
                                     data-testid='partner-transactions-search-text'
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={ (e)=>{
                                         if (e.key === 'Enter') {
                                             this.props.search();
                                         }}
                                     }
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>
                    <Col xs={8}     md={6} sm={6} className="top10 pright0"   data-testid='partner-transactions-from-paid-date'>
                        <Col xs={6} className="pleft0  pright5">
                            <Datetime dateFormat={'MM-DD-YYYY'}  timeFormat={false}

                                      onChange={(value) => {
                                          this.setState({'filterOptions': {...this.state.filterOptions, 'fromPaidDateDisplay': value}});
                                      }  }
                                      value={this.state.filterOptions.fromPaidDateDisplay}
                                      inputProps={{placeholder: 'From Paid Date'}}/>
                        </Col>
                        <Col xs={6} className="pleft7 pright0"      data-testid='partner-transactions-to-paid-date'>
                            <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}

                                      onChange={(value) => {
                                          this.setState({'filterOptions': {...this.state.filterOptions, 'toPaidDateDisplay': value}});
                                      }}
                                      value={this.state.filterOptions.toPaidDateDisplay}
                                      inputProps={{placeholder: 'To Paid Date'}}/>
                        </Col>
                    </Col>
                  <Col xs={9}  sm={4}  md={4} lg={3}   className="top10"  data-testid='partner-transactions-type-select'>
                    <Select

                      tabIndex="0"
                      multi
                      placeholder="Type"
                      clearable={true}
                      options={ config.transactionTypesMap.filter(item=>['Sale', 'Fee', 'Credit'].includes(item.value))}
                      onChange={(selectedOptions)=> {
                        this.setState({
                          'filterOptions': {
                            ...this.state.filterOptions,
                            Types: selectedOptions
                          }
                        });
                      }}
                      value={self.state.filterOptions.Types}
                    />
                  </Col>
                </Row>
                <Row>

                    <Col xs={8} md={3} sm={3} className=" top10 pright0"   data-testid='partner-transactions-seller-select'>
                        <Select

                            tabIndex="0"
                            placeholder="Seller"
                            clearable={true}
                            options={this.allSellersOptionsList}
                            onChange={this.onSellerChange.bind(this)}
                            value={this.state.filterOptions.SellerID}
                        />
                    </Col>
                    <Col xs={8}     md={6} sm={6} className="top10 pright0"   data-testid='partner-transactions-from-fulfilled-date'>
                        <Col xs={6} className="pleft0  pright5">
                            <Datetime dateFormat={'MM-DD-YYYY'}  timeFormat={false}

                                      onChange={(value) => {
                                          this.setState({'filterOptions': {...this.state.filterOptions, 'fromFulfilledTimeDisplay': value}});
                                      }  }
                                      value={this.state.filterOptions.fromFulfilledTimeDisplay}
                                      inputProps={{placeholder: 'From Fulfilled Date'}}/>
                        </Col>
                        <Col xs={6} className="pleft7 pright0"     data-testid='partner-transactions-to-fulfilled-date'>
                            <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                      onChange={(value) => {
                                          this.setState({'filterOptions': {...this.state.filterOptions, 'toFulfilledTimeDisplay': value}});
                                      }  }
                                      value={this.state.filterOptions.toFulfilledTimeDisplay}
                                      inputProps={{placeholder: 'To Fulfilled Date'}}/>
                        </Col>
                    </Col>


                </Row>


                <Row>


                    <Col md={3} xs={6} className="pull-right top10">
                        <button className="pull-right btn btn-primary"
                                data-testid='partner-transactions-search-button'
                                disabled={this.props.pending}
                                onClick={(event) => self.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>
                </Row>
            </div>
        );

    }
}



